import { ScopeButton, ScopeGroup } from './settingsEntities.styles';

export type Scope = 'all' | 'project' | 'global';

const OPTIONS: { value: Scope; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'project', label: 'Project' },
  { value: 'global', label: 'Global' },
];

type Props = {
  value: Scope;
  onChange: (scope: Scope) => void;
};

export const ScopeFilter = ({ value, onChange }: Props) => (
  <ScopeGroup role="group" aria-label="Scope filter">
    {OPTIONS.map(({ value: v, label }) => (
      <ScopeButton key={v} type="button" selected={value === v} aria-pressed={value === v} onClick={() => onChange(v)}>
        {label}
      </ScopeButton>
    ))}
  </ScopeGroup>
);

export default ScopeFilter;
